// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"lq-z","summaryPar":"mq-z","ratingCategories":"nq-z","reviewerInfo":"oq-z","reviewTypes":"pq-z","expanded":"qq-z"};